export const encodeToBase64 = (input: string): string => {
  try {
    const str = typeof input === "string" ? input : JSON.stringify(input);
    const bytes = new TextEncoder().encode(str);
    const binary = Array.from(bytes, (b) => String.fromCharCode(b)).join("");
    return btoa(binary);
  } catch (error) {
    console.error("Error encoding to Base64:", error);
    return "";
  }
};
